import { useSelector } from 'react-redux';

import { useGetSiteConsentByTypeQuery } from '../site/new-user-journey/consentApi';
import { selectSite } from '../site/siteSlice';
import { selectUser } from '../user/userSlice';

export const useOnboardingWizardProgress = () => {
  const site = useSelector(selectSite);
  const user = useSelector(selectUser);
  const isSystemOwner = user.role === 'SYSTEM_OWNER';

  const { data: shareDataWithCustomerSupportConsent, isLoading: isSiteConsentsLoading } =
    useGetSiteConsentByTypeQuery('SHARE_WITH_CUSTOMER_CARE');

  return {
    needsSiteAddress: !site.address,

    // This consent needs to be provided by the user if they are the system owner and the site has not yet provided it
    needsToProvideCustomerSupportConsent: isSystemOwner && !shareDataWithCustomerSupportConsent,

    // At least one device is required to be configured
    needsToConfigureHardware: !site.devices.length,

    // This will be used only when moving from the configure hardware page to the tariffs page
    needsToVisitTariffs: site.isOnboarding,

    needsToVisitEnergyModes: false,

    isLoaded: !isSiteConsentsLoading,
  };
};
